var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2205 18.0063H7.89282V42.4271H39.2205V18.0063Z",
    fill: "url(#pattern0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0631 20.0376H21.7056L10.0195 31.7265L16.6969 38.4038L35.0631 20.0376Z",
    fill: "#54C5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68014 28.3864L0 21.7063L21.7063 0H35.0638L6.68014 28.3864Z",
    fill: "#54C5F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6975 38.4039L21.7062 43.4126H35.0637L23.3749 31.7266L16.6975 38.4039Z",
    fill: "#01579B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6975 38.4039L26.6035 34.9747L23.3749 31.7266L16.6975 38.4039Z",
    fill: "url(#paint0_linear_101_340)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6966 25.0456L10.019 31.7231L16.6966 38.4007L23.3741 31.7231L16.6966 25.0456Z",
    fill: "#29B6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0638 20.0376L23.3777 31.7237L35.0638 43.4126H21.7063L16.6976 38.4039L10.0174 31.7237L21.7063 20.0376H35.0638ZM21.7063 0L0 21.7063L6.68014 28.3864L35.0638 0H21.7063Z",
    fill: "url(#paint1_radial_101_340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_101_340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_340",
    x1: 18.6447,
    y1: 39.6934,
    x2: 23.6192,
    y2: 34.7189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.986641 2.95995) scale(53.1128 53.1128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_101_340",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABkCAYAAABO6zhfAAAACXBIWXMAAAx0AAAMdAH/P3aRAAAA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterLogo);
export default __webpack_public_path__ + "static/media/flutter-logo.8d1ff62acded3f55cfb6d8a0de8ec4e6.svg";
export { ForwardRef as ReactComponent };